import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const HelpFilledIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <circle cx={14} cy={10.852} r={7.75} fill="currentColor" />
    <path
      fill="currentColor"
      stroke="#F2F0EB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.495 16.594H10.504a4.009 4.009 0 0 1 3.996 3.997v.633h0a2.127 2.127 0 0 1-2.12 2.122H3.62h0-.004a2.127 2.127 0 0 1-2.12-2.121v-.005a.75.75 0 0 1 .342-.627l.001-.001a.75.75 0 0 1 .404-.12h.002v-.002h.003a3.259 3.259 0 0 1 3.246-3.126m0-.75v.75m0-.75h-.002m.002 0h-.002m.002.75H10.5a3.259 3.259 0 0 1 3.25 3.25v.629a1.377 1.377 0 0 1-1.374 1.373H3.62a1.376 1.376 0 0 1-1.149-.624h-.222v-.002h-.002a.75.75 0 0 1-.75-.75v-.629h0a4.008 4.008 0 0 1 3.997-3.997s0 0 0 0m.002.75-.002-.75"
    />
    <path
      fill="currentColor"
      stroke="#F2F0EB"
      strokeWidth={1.5}
      d="M8.018 9.11a4.001 4.001 0 0 0-4.02 3.97v.004a4.007 4.007 0 0 0 1.162 2.844l.532-.529-.532.529a4.007 4.007 0 0 0 2.835 1.184h.003A4.001 4.001 0 0 0 12 13.121v0A4.001 4.001 0 0 0 8.02 9.11h0Z"
    />
    <circle cx={15} cy={10.842} r={1} fill="#fff" />
    <circle cx={18} cy={10.842} r={1} fill="#fff" />
  </IconBase>
);
